export const SummaryValueColumns = ['credits_from_study', 'income_tax_allocation', 'payroll_allocation']
export const SummaryDateColumns = ['year_of_study', 'date_return_filed']
